import { DurationParser } from '@internetarchive/field-parsers';
import { MetadataField } from '../metadata-field';
/**
 * The DurationField parses different duration formats
 * and returns a `Duration`, which is a number in seconds
 * with decimals.
 *
 * @export
 * @class DurationField
 * @extends {MetadataField<Duration, DurationParser>}
 */
export class DurationField extends MetadataField {
    constructor(rawValue) {
        super(DurationParser.shared, rawValue);
    }
}
//# sourceMappingURL=duration.js.map